module.exports = __webpack_public_path__ + "static/media/plaquette_abcs.e5af380e.pdf";